import type { WalletType } from '@/lib/observability/shared/wallet-type'

import type { AnalyticsVaultVersion } from '../events'
import { trackAnalyticsEvent } from '../track'

export interface VaultDepositAnalyticsMetadata {
  vaultAddress: string
  vaultVersion: AnalyticsVaultVersion
  assetSymbol: string
  amountRaw: string
  amountUsd: number
}

interface VaultDepositCompletedParams extends VaultDepositAnalyticsMetadata {
  chainId: number
  chainName: string
  walletType: WalletType
  walletProvider: string
}

export function trackVaultDepositCompleted(params: VaultDepositCompletedParams) {
  trackAnalyticsEvent('vault_deposit_completed', {
    vault_address: params.vaultAddress,
    vault_version: params.vaultVersion,
    chain_id: params.chainId,
    chain_name: params.chainName,
    asset_symbol: params.assetSymbol,
    amount_raw: params.amountRaw,
    amount_usd: params.amountUsd,
    wallet_type: params.walletType,
    wallet_provider: params.walletProvider
  })
}
